<template>
    <el-dialog
        title="作品详情"
        :visible.sync="workMessExamine"
        width="1000px" :close-on-click-modal="false">
        <div class="examine">
            <h2>报名信息</h2>
            <div class="examineList">
                <p>报名时间 :</p>
                <p>{{ sign.createTime }}</p>
            </div>
            <div class="examineList examineListTwo">
                <div class="examineListTwo_box">
                    <p style="white-space:nowrap">昵&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;称 :</p>
                    <p>{{ sign.nickName }}</p>
                </div>
                <div class="examineListTwo_box">
                    <p style="white-space:nowrap">姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名 :</p>
                    <p>{{ sign.name }}</p>
                </div>
            </div>

            <div class="examineList examineListTwo">
                <div class="examineListTwo_box">
                    <p style="white-space:nowrap">账&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;号:</p>
                    <p>{{ sign.account }}</p>
                </div>
                <div class="examineListTwo_box">
                    <p>联系电话:</p>
                    <p>{{ sign.tel }}</p>
                </div>
            </div>

            <div class="examineList examineListTwo">
                <div class="examineListTwo_box">
                    <p>参赛主体 :</p>
                    <p>{{ sign.signTypeCn }}</p>
                </div>
            </div>

            <div class="examineList examineListTwo">
                <div class="examineListTwo_box">
                    <p>单位院校 :</p>
                    <p>{{ sign.teamName }}</p>
                </div>
                <div class="examineListTwo_box">
                    <p>指导老师 :</p>
                    <p>{{ sign.teamMember }}</p>
                </div>
            </div>
        </div>
        <div class="examine">
            <h2>作品信息</h2>
            <div class="examineList">
                <p>活动名称 :</p>
                <p>{{ info.activityName }}</p>
            </div>
            <div class="examineList">
                <p>赛道名称 :</p>
                <p>{{ info.activityWayName }}</p>
            </div>
            <div class="examineList">
                <p>作品类别 :</p>
                <p>{{ info.typeName }}</p>
            </div>
            <div class="examineList">
                <p>作品封面 :</p>
                <img :src="info.coverUrl" alt="">
            </div>
            <div class="examineList">
                <p>作品编号 :</p>
                <p>{{ info.code }}</p>
            </div>
            <div class="examineList">
                <p>作品名称 :</p>
                <p>{{ info.name }}</p>
            </div>

            <div class="examineList_html">
                <p>作品简介 :</p>
                <p v-html="info.summary" class="vHtml"></p>
            </div>
            <div class="examineList_html">
                <p>作品说明 :</p>
                <p v-html="info.description" class="vHtml vHtmlMess"></p>
            </div>
            <!--<div class="examineList">
                <p>参赛作品 :</p>
                <p style="color: #1890FF;cursor: pointer;" @click="downloadFile(info.worksUrl,info.worksName)">{{ info.worksName }}</p>
            </div>-->
            <div class="examineList">
                <p style="white-space:nowrap">参赛作品 :</p>
                <div>
                  <!--<p style="color: #1890FF;cursor: pointer;width:100%"
                    v-if="worksFileList.length>0"
                    v-for="(item,index) in worksFileList"
                    :key="index"
                    @click="downloadFile(item.url,item.name)">
                      {{ item.name }}
                  </p>     -->
                     <el-popconfirm
                        v-if="worksFileList.length>0"
                        v-for="(item,index) in worksFileList"
                        :key="index"
                        @confirm="viewInfo(item.url,item.name)"
                        @cancel="downloadFile(item.url,item.name)"
                        confirm-button-text='预览'
                        cancel-button-text='下载'
                        icon="el-icon-info"
                        title="请选择操作"
                        width="250"
                    >
                    <!--<el-popconfirm
                        v-if="worksFileList.length>0"
                        v-for="(item,index) in worksFileList"
                        :key="index"
                        @confirm="downloadFile(item.url)"
                        confirm-button-text='下载'
                        icon="el-icon-info"
                        title="请选择操作"
                    >-->
                        <el-button slot="reference" style="margin-right:10px;margin-bottom:10px">{{ item.name }}</el-button>
                    </el-popconfirm>
                </div>

            </div>
        </div>
        <div class="examine">
          <h2>评分信息</h2>
          <div class="examineList2 examineListTwo">
            <div class="examineListTwo_box">
              <p>投票数量:</p>
              <p>{{ info.voteNum }}</p>
            </div>
            <div class="examineListTwo_box">
              <p>投票得分:</p>
              <p>{{ info.voteScore }}</p>
            </div>
          </div>
            <!--<div class="examineList2 examineListTwo">
                <div class="examineListTwo_box">
                    <p>作品总分:</p>
                    <p>{{ info.score }}</p>
                </div>
            </div>-->
            <div :class="tableData.length != 0?'examineList_mess':'examineList2'">
                <p>评委评分记录:</p>
                <el-table
                    v-if="tableData.length != 0"
                    :data="tableData"
                    border
                    style="width: 100%">
                    <el-table-column
                        prop="userName"
                        label="评委名称"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="score"
                        label="评分"
                        width="180">
                        <template slot-scope="scope">
                            {{ scope.row.score==null?'':scope.row.score}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="remark"
                        label="意见">
                    </el-table-column>
                    <el-table-column
                        prop="createTime"
                        label="评分时间">
                    </el-table-column>
                </el-table>
                <p v-else>未评分</p>
            </div>
            <div class="examineList2 examineListTwo">
                <div class="examineListTwo_box">
                    <p>评委评分:</p>
                    <p>{{ info.score }}</p>
                </div>
            </div>
            <div class="examineList2 examineListTwo">
                <div class="examineListTwo_box">
                    <p>作品总分:</p>
                    <p>{{ (info.voteScore + info.score).toFixed(2) }}</p>
                </div>
            </div>
            <div :class="leaderList.length != 0?'examineList_mess':'examineList2'" v-if="info.leaderAudit">
                <p>领导审核记录:</p>
                <el-table
                    v-if="leaderList.length != 0"
                    :data="leaderList"
                    border
                    style="width: 100%">
                    <el-table-column
                        prop="userName"
                        label="领导名称"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="status"
                        label="审核"
                        width="180">
                        <template slot-scope="scope">
                            {{ scope.row.status=='PASS'?'已审核':scope.row.status=='REJECT'?'已拒绝':'未审核' }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="remark"
                        label="意见">
                    </el-table-column>
                    <el-table-column
                        prop="createTime"
                        label="评分时间">
                    </el-table-column>
                </el-table>
                <p v-else>未审核</p>
            </div>
          <!--<div class="examineList2 examineListTwo">
            <div class="examineListTwo_box">
              <p>评委评分:</p>
              <p>{{ info.score }}</p>
            </div>
            <div class="examineListTwo_box">
              <p>领导审核记录:</p>
              <p>{{ info.reviewStatus }}</p>
            </div>
          </div>
          <div class="examineList2">
            <p>作品总分:</p>
            <p>{{ info.score }}</p>
          </div>-->
        </div>
        <!--<el-dialog
            title="图片预览"
            :close-on-click-modal="false"
            :append-to-body="true"
            :visible.sync="visibleImg">
            <div class="modal-content">
                <el-row v-if="isShowImgUpload" style="padding-left:100px;padding-right:100px;">
                    <el-col :span="4" style="color:white">1</el-col>
                    <el-col :span="16">
                        <div style="position:relative;background-color: #f0f3fa;">
                            <img
                                :src="localUrl"
                                :preview-src-list="[localUrl]"
                                style="width:100%;height:100%;"
                                fit="scale-down"
                            />
                        </div>
                    </el-col>
                    <el-col :span="4" style="color:white">1</el-col>
                </el-row>
            </div>
        </el-dialog>
        <three-d
            ref="threeBox"
            :innerVisible="innerVisible"
            :fileListNew="fileListNew"
            @closeDlog="closeDlog"
        ></three-d>-->
        <view-file-dialog ref="viewFileDialog" ></view-file-dialog>
    </el-dialog>

</template>

<script>
    import viewFileDialog from './viewFileDialog';
    import threeD from "../../../components/threeD/index"
    import { getWorksDetail, getWorksScoreInfo, getExamineWorksList, getJudgesWorksScoreInfo } from '../../../utils/interface';
    export default {
        name: "examineDialog",
        data() {
            return{
                workMessExamine: false,
                info:{},
                sign:{},
                tableData: [],
                leaderList:[],
                worksFileList:[],
                // 3D预览
                fileListNew: [],
                innerVisible: false,
                // 图片预览
                isShowImgUpload:false,
                localUrl:"",
                visibleImg:false,
                orderRecordList:[],
            }
        },
        components:{
            threeD,
            viewFileDialog
        },
        methods: {
            init(uuid) {
                this.workMessExamine = true;
                getWorksDetail(uuid).then((res)=>{
                    this.info = res.info;
                    this.sign = res.sign;
                    this.worksFileList = this.info.worksFileList;
                    getWorksScoreInfo({worksUuid:uuid}).then((res)=>{
                        this.tableData = res.data;
                    });
                    if (info.leaderAudit) {
                        getExamineWorksList({worksUuid:uuid}).then((res)=>{
                            this.leaderList = res.data;
                        });
                    }
                });
            },
            downloadFile(fileUrl,fileName){
                this.open1();
                this.$refs.viewFileDialog.init("download", fileName , fileUrl);
            },
            viewInfo(fileUrl){
                let fileType = fileUrl.substr(fileUrl.lastIndexOf('.')+1).toUpperCase();
                this.$refs.viewFileDialog.init("view", fileType, fileUrl);
            },
            closeDlog(index){
                this.innerVisible = index;
            },
            showImg (url) {
                this.visibleImg = true;
                this.localUrl = url;
                this.isShowImgUpload = true;//呈现本地预览组件
            },
            open1() {
                const h = this.$createElement;
                this.$notify({
                    title: '提示',
                    message: h('i', { style: 'color: teal'}, '正在准备下载资源请稍后!'),
                    duration: 12000
                });
            },
        }
    }
</script>

<style scoped lang="less">
/deep/.el-dialog__body {
  padding-top: 0;
}
.examine {
  h2 {
      font-weight: 700;
      font-size: 16px;
      color: #000;
      margin-top: 26px;
      letter-spacing: 1px;
  }
  .examineList {
    display: flex;
    img {
      width: 300px;
      height: 150px;
    }
    p:nth-of-type(1){
      margin-right: 16px;
      width: 65px;
      flex-shrink: 0;
    }
    .vHtml {
      margin: 0;
      /deep/img {
        max-width: 100%;
      }
    }
    .examine_html {
      width: 90%;
      /deep/pre {
          white-space: pre-line !important;
      }
      /deep/img {
          max-width: 100%;
      }
    }
  }
  .examineList_html {
    img {
      width: 300px;
      height: 150px;
    }
    p:nth-of-type(1){
      margin-right: 16px;
      width: 65px;
      flex-shrink: 0;
    }
    .vHtml {
      margin: 0;
      /deep/img {
        max-width: 100%;
      }
    }
  }
  .examineListTwo {
    display: flex;
    align-items: center;
    .examineListTwo_box {
      display: flex;
      align-items: center;
      width: 50%;
      p {
        flex-shrink: 0;
      }
    }
  }
  .examineList2 {
    display: flex;
    align-items: center;
    p:nth-of-type(1){
      margin-right: 16px;
      width: 105px;
    }
  }
  .examineList_mess {

  }
}
/deep/img {
    max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/activityManagement/activeDialog/worksDetailsDialog.vue